// Copyright (c) 2016 Deere & Company

import {
    resetSearchCriteria,
    updateAllDealersOnLoad,
    updateMaintenancePlanAttributesCriteria,
    updateMaintenancePlanPlanEndDate,
    updateMaintenancePlanPlanStartDate,
    updateMaintenancePlanSelectAllDealers,
    updateMaintenancePlanSelectAllServiceIntervalStatuses,
    updateMaintenancePlanSelectedDealers,
    updateMaintenancePlanSelectedServiceIntervalStatuses,
    updateMaintenancePlanServiceIntervalBeginDate,
    updateMaintenancePlanServiceIntervalEndDate

} from './criteria';
import {createMaintenancePlanReport} from './report';
import {sharedActionCreators} from '../../shared/action-creators';
import {updatePlanNames} from './update-plan-names';
import {updateServiceIntervalStatuses} from './update-service-interval-statuses';
import {updateServiceIntervalTypes} from './update-service-interval-types';

export default {
    createMaintenancePlanReport,
    resetSearchCriteria,
    updateAllDealersOnLoad,
    updateMaintenancePlanAttributesCriteria,
    updateMaintenancePlanPlanEndDate,
    updateMaintenancePlanPlanStartDate,
    updateMaintenancePlanSelectAllDealers,
    updateMaintenancePlanSelectAllServiceIntervalStatuses,
    updateMaintenancePlanSelectedDealers,
    updateMaintenancePlanSelectedServiceIntervalStatuses,
    updateMaintenancePlanServiceIntervalBeginDate,
    updateMaintenancePlanServiceIntervalEndDate,
    updatePlanNames,
    updateServiceIntervalStatuses,
    updateServiceIntervalTypes,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/action-creators/index.js